import backend from '../../components/utils/backend'

export default {
  state: {
    users: {}
  },
  mutations: {
    'SET_USERS': function (state, users) {
      state.users = users
        .reduce((total, current) => {
          total[current.sfmcId + ''] = current
          return total
        }, {})
    },
    'UPDATE_USER': function (state, user) {
      state.users[user.sfmcId + ''] = user
    }
  },
  actions: {
    getUsers ({ commit, rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = (await backend.get('/api/v1/user', rootGetters['session/accessToken']))
          if (response.statusCode !== 200) {
            console.error('Error during read', response.body)
            throw new Error(response.body.moreInformation)
          } else {
            commit('SET_USERS', response.body)
            resolve(response.body)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    updateUser ({ commit, rootGetters }, user) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await backend.put(`/api/v1/user/${user.sfmcId}`, rootGetters['session/accessToken'], user)
          if (response.statusCode !== 200) {
            console.error('Error during read', response.body)
            throw new Error(response.body.moreInformation)
          } else {
            commit('UPDATE_USER', response.body)
            resolve(response.body)
          }
        } catch (error) {
          reject(error)
        }
      })
    }
  },
  getters: {
    userList: state => Object.values(state.users)
  },
  namespaced: true
}
